import { APP_BASE_HREF, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonTLFModule } from './common/common.module';
import { interceptorProviders } from './common/interceptors/interceptors.providers';
import { DynamicFormModule } from './core/components/dynamic-form/dynamic-form.module';
import { CoreModule } from './core/core.module';
import { modaleRicerca } from './search/components/modale-ricerca/ricerca-modale.component';
import { LayoutModule } from '@angular/cdk/layout';
import { ProfileGuard } from './utility/guards/profile/profile.guard';
import { appInitializer } from './app-initializer';
import { SsoStrategyService } from './sso-strategy.service';
import { OauthService } from './oauth.service';
import { DialogService } from './core/components/dialog/dialog.service';
import { HelpersService } from './core/services/helpers.service';
import { UserManager } from './core/services/user-manager';

registerLocaleData(localeIt, 'it-IT');

// FIXME: This methods are deprecated on Typescript 4.4 but used in project
declare global {
  interface Navigator {
    msSaveBlob?: (blob: Blob, filename: string) => void;
    msSaveOrOpenBlob?: (blobOrBase64: Blob | string, filename: string) => void;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    modaleRicerca,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    CoreModule,
    NgSelectModule,
    FormsModule,
    DynamicFormModule,
    ReactiveFormsModule,
    NgbModule,
    LayoutModule,
    HttpClientModule,
    CommonTLFModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
  ],
  providers: [
    ProfileGuard, {
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  },
  {
    provide: APP_INITIALIZER,
    useFactory: appInitializer,
    deps: [SsoStrategyService, Router, OauthService, HelpersService, UserManager, DialogService],
    multi: true,
  },
  {
    provide: APP_BASE_HREF,
    useValue: '/'
  },
    interceptorProviders,
    // { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },

    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: CRSFtokenInterceptor,
    //   multi: true
    // },
    // { provide: HttpRequest, useClass: HttpRequest },
    /*{
      provide: HTTP_INTERCEPTORS,
      useClass: MessagesInterceptor,
      multi: true
    }*/
  ],
  exports: [modaleRicerca],
  bootstrap: [AppComponent]
})
export class AppModule { }
